import styled from 'styled-components'


const LogoStyle = styled.div.attrs()`
    width: var(--sp8x);
    height: var(--sp3-5x);
    position: relative;

    img {
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        object-fit:contain;
    }
`
export default LogoStyle
